import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import App from './App';
import './index.css';

const rootEl = document.getElementById('root');
if (rootEl === null) {
  throw new Error('Missing #root in index.html');
}

// Service Worker auto-update (PWA)
registerSW({
  immediate: true,
  onRegistered(reg) {
    if (reg) {
      console.info('[positec] Service Worker registrado');
    }
  },
  onRegisterError(err) {
    console.warn('[positec] error registrando Service Worker', err);
  },
});

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
